import './Menu.css'
import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import { docs } from './config'
import logo from './assets/docs.svg'

const Menu = ({ match }) => {
  const paths = [...docs.keys()].sort((a, b) => {
    return docs.get(a).order > docs.get(b).order
  })
  return (
    <nav className="Menu">
      <header className="Menu_header">
        <a href="https://docs.small.chat">
          <img src={logo} alt="smallchat logo" />
        </a>
      </header>
      <ul>
        {paths.map(path => (
          <li className="Menu_links" key={path}>
            <NavLink to={`/${path}`}>
              {docs.get(path).title || path}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}

Menu.displayName = 'Menu'

export default Menu



// WEBPACK FOOTER //
// ./src/Menu.js